import { CHANNEL_BADGE } from "@/lib/channels";

const statusStyles = {
  "PRE-BOOKING": "bg-purple-100 text-purple-800 border-purple-200",
  "ON-PROCESS": "bg-amber-100 text-amber-800 border-amber-200",
  UPCOMING: "bg-blue-100 text-blue-800 border-blue-200",
  "CHECKED-IN": "bg-sky-100 text-sky-800 border-sky-200",
  "CHECKED IN": "bg-sky-100 text-sky-800 border-sky-200",
  "CHECKED-OUT": "bg-slate-200 text-slate-700 border-slate-300",
  "CHECKED OUT": "bg-slate-200 text-slate-700 border-slate-300",
  VACANT: "bg-slate-100 text-slate-600 border-slate-200",
  CANCELLED: "bg-rose-100 text-rose-800 border-rose-200",
};

const paymentStyles = {
  PAID: "bg-blue-900 text-white border-blue-900",
  PENDING: "bg-amber-100 text-amber-900 border-amber-200",
  REFUNDED: "bg-rose-100 text-rose-800 border-rose-200",
  "NOT APPLICABLE": "bg-slate-100 text-slate-500 border-slate-200",
  "N/A": "bg-slate-100 text-slate-500 border-slate-200",
};

export default function StatusBadge({ value, type = "status" }) {
  if (!value) return <span className="text-xs text-slate-400">—</span>;
  let cls, label;
  if (type === "channel") {
    cls = CHANNEL_BADGE[value] || "bg-slate-100 text-slate-700 border-slate-200";
    label = value;
  } else if (type === "payment") {
    const v = String(value).toUpperCase();
    cls = paymentStyles[v] || "bg-slate-100 text-slate-700 border-slate-200";
    label = v;
  } else {
    const v = String(value).toUpperCase();
    cls = statusStyles[v] || "bg-slate-100 text-slate-700 border-slate-200";
    label = v;
  }
  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-sm border text-[10px] font-semibold uppercase tracking-wider whitespace-nowrap ${cls}`}
    >
      {label}
    </span>
  );
}
